// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"9ca0d29f","111":"5a5f29de","401":"d10d9e71"}[chunkId] + ".chunk.js";
};